module.exports = "<div *ngIf=\"step === 'one'\">\n  <app-step-one></app-step-one>\n</div> <!-- end step 1 -->\n"